'use client';

import { useState } from 'react';
import { Logo } from '../Logo';
import { navigationItems, companyInfo } from '@/lib/constants';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <a
        href="#main"
        className="sr-only rounded-chart bg-beacon px-4 py-2 text-vellum focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
      >
        Skip to main content
      </a>
      <header className="sticky top-0 z-40 border-b border-rule bg-chart/90 backdrop-blur">
        <nav
          className="mx-auto flex w-full max-w-sheet items-center justify-between px-6 py-3.5 md:px-10"
          aria-label="Main navigation"
        >
          <a
            href="#main"
            className="flex items-center gap-3 rounded-chart text-ink"
          >
            <Logo className="h-8 w-8" />
            <span className="font-display text-[0.95rem] font-semibold uppercase tracking-[0.16em]">
              <span className="hidden sm:inline">{companyInfo.name}</span>
              <span className="sm:hidden">Red Eye</span>
            </span>
          </a>

          <ul className="hidden items-center gap-8 md:flex">
            {navigationItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="marginalia rounded-chart text-ink-soft transition-colors hover:text-beacon"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <button
            className="-mr-2 rounded-chart p-2 text-ink md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation menu"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 8h16M4 16h16" />
              )}
            </svg>
          </button>
        </nav>

        {isMenuOpen && (
          <ul className="border-t border-rule px-6 py-2 md:hidden">
            {navigationItems.map((item) => (
              <li
                key={item.href}
                className="border-b border-rule last:border-0"
              >
                <a
                  href={item.href}
                  className="marginalia block rounded-chart py-3.5 text-ink-soft"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </header>
    </>
  );
}
